// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 래퍼 (그리드 2행: 위 1fr = 콘텐츠, 아래 auto = 키패드) */
.login-wrap {
    position: relative;
    width: 100%;
    height: 100dvh;
    background: #fff;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: #111;
    display: grid;
    grid-template-rows: 70px 1fr auto;
}

/* ===== 상태바(상단) — 필요 시 사용 ===== */
.login-topbar {
    position: absolute;
    top: 8px;
    left: 14px;
    right: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    z-index: 2;
}

.login-time {
    font-weight: 700;
    font-size: 16px;
}

.login-status {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}

.login-signal {
    width: 18px;
    height: 10px;
    position: relative;
    display: inline-block;
    border-right: 2px solid #000;
}

.login-signal::before,
.login-signal::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 2px;
    width: 3px;
    background: #000;
    border-radius: 1px;
}

.login-signal::before {
    height: 6px;
}

.login-signal::after {
    left: 8px;
    height: 9px;
}

.login-5g {
    font-size: 14px;
}

.login-battery {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    background: #000;
    color: #fff;
    font-size: 12px;
}

.login-battery-level {
    transform: translateY(0.5px);
}

/* ===== 헤더/카드 — 주석 상태 유지 ===== */
.login-header {
    padding: 20px 24px 0;
}

.login-back {
    position: absolute;
    top: 50px;
    left: 0px;
    border: none;
    background: none;
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    color: #222;
    padding: 20px;
}

.login-card {
    margin-top: 25px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px 16px;
    align-items: center;
    padding: 14px 16px;
    border-radius: 12px;
    background: #f7f7f8;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.login-card-left {
    min-width: 0;
}

.login-name {
    font-size: 18px;
    font-weight: 800;
}

.login-card-right {
    display: grid;
    gap: 6px;
    color: #6d6d6d;
    font-size: 14px;
}

.login-meta span {
    color: #9b9b9b;
    margin-right: 8px;
}

/* ===== 상단 콘텐츠(중앙 정렬) ===== */
.login-main {
    min-height: calc(100dvh - 70px);
    display: grid;
    grid-template-rows: 50px 1fr auto;
}

/* ===== 타이틀 ===== */
.login-title {
    /* 기존: margin: 100px 24px 0;  → 중앙정렬 레이아웃에 맞게 수정 */
    margin: 0 24px 14px;
    text-align: center;
    font-size: clamp(22px, 5.6vw, 30px);
    font-weight: 900;
}

/* ===== PIN 점 표시 ===== */
.login-pin-dots {
    margin-top: 6px;
    display: flex;
    justify-content: center;
    gap: 18px;
}

.login-dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #cfcfd3;
}

.login-dot.filled {
    background: #4a4a4a;
}

/* ===== 본문 안내 ===== */
.login-desc {
    margin-top: 12px;
    text-align: center;
    color: #6c6c6c;
    font-size: 16px;
    line-height: 1.5;
}

.login-desc-sub {
    margin: 28px 24px 0;
    text-align: center;
    color: #6c6c6c;
    font-size: 15px;
    line-height: 1.6;
}

/* ===== 섹션 타이틀(밑줄) — 필요시 사용 ===== */
.login-section {
    margin: 36px 24px 12px;
    text-align: center;
    font-weight: 800;
    color: #4b4f58;
    font-size: 20px;
    position: relative;
}

.login-section span {
    border-bottom: 3px solid #4b4f58;
    display: inline-block;
    padding-bottom: 4px;
}

/* ===== 키패드 (그리드 2행에 배치) ===== */
.login-keypad {
    position: static;
    left: auto;
    right: auto;
    bottom: auto;
    background: #2f3a55;
    color: #fff;
    padding: 10px 24px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: clamp(45px, 7vh, 60px);
    gap: 10px 15px;
    justify-items: center;
    align-items: center;
}

.login-keypad button {
    width: 100%;
    max-width: 120px;
    height: 64px;
    border: none;
    background: transparent;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
    cursor: pointer;
    pointer-events: auto;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
}

.login-keypad button:active {
    transform: scale(0.98);
    background-color: #2a344d;
}

/* 특수키(좌/우 폭 넓게) */
.key-wide {
    max-width: none;
    width: 100%;
    font-size: 22px;
    font-weight: 800;
    text-transform: uppercase;
}

.key-clear {
    font-size: 20px !important;
}

.key-back {
    font-size: 20px !important;
}

.login-top-logo {
    padding-top: 20px;
    display: flex;
    justify-content: center;
}

.login-top-logo img {
    height: 40px;
    object-fit: contain;
}







/* Google 단계 전체 정렬 */

.google-regist {
    display: flex;
    flex-direction: column;
}

.google-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.google-circle-icon {
    width: 100px;
    margin-bottom: 15px;
}

/* 가운데 텍스트 */
.google-center-text {
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.7;
    white-space: pre-line;
}

.google-center-text::first-line {
    font-size: 20px;
    font-weight: 700;
}

.google-accent {
    color: #e53935;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
}

.google-inline-icon {
    margin-right: 4px;
}

.google-word {
    margin-right: 2px;
}

/* 하단 버튼 영역 */
.google-bottom-area {
    width: 100%;
    padding: 10px 24px 32px;
}

/* 회원가입 단계에서 하단 고정 */
.google-regist .google-bottom-area {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 100;
    padding: 10px 24px calc(32px + env(safe-area-inset-bottom));
}

.google-bottom-btn {
    width: 100%;
    padding: 14px 0;
    border-radius: 8px;
    border: none;
    background: #f0f0f0;
    color: #111;
    font-size: 16px;
    font-weight: 600;
}

.google-bottom-btn:disabled {
    opacity: 0.7;
}

/* 구글 공식 Sign-In 버튼 스타일 */
.google-signin-btn {
    width: 100%;
    max-width: 400px;
    height: 50px;
    padding: 0 24px;
    border-radius: 4px;
    border: 1px solid #dadce0;
    background: #ffffff;
    color: #3c4043;
    font-size: 14px;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.2s ease, background-color 0.2s ease;
    margin: 0 auto;
}

.google-signin-btn:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    background-color: #f8f9fa;
}

.google-signin-btn:active {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    background-color: #f1f3f4;
}

.google-signin-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.2);
}

.google-signin-icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
}

.google-signin-text {
    font-size: 15px;
    font-weight: 500;
    color: #3c4043;
    letter-spacing: 0.25px;
}

/* 닫기 텍스트 스타일 */
.login-close-text {
    display: block;
    text-align: center;
    color: #999;
    font-size: 14px;
    font-weight: 400;
    padding: 10px 0;
}

/* 구글 로그인 화면 전체를 더 크게 중앙에 */
.google-main-large {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* 세로 중앙 */
    /* align-items: center; */
    /* padding: 40px 24px 24px; */
}

/* 아이콘 크게 */
.google-circle-icon-large {
    width: 140px;
    height: 140px;
    object-fit: contain;
}

/* 텍스트도 조금 키움 */
.google-center-text-large {
    font-size: 20px;
    line-height: 1.7;
}

/* 하단 영역 여유 */
.google-bottom-area-large {
    padding: 0 20px 40px;
}

/* 버튼 키우기 */
.google-bottom-btn-large {
    width: 100%;
    height: 56px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 600;
}

.login-user-card {
    width: 90%;
    /* max-width: 360px; */
    padding: 12px 16px;
    border-radius: 12px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    /* position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%); */
    border: 1px solid #e5e5e5;
    margin: 0 auto;
}

.login-user-name {
    font-size: 16px;
    font-weight: 600;
}

.login-user-email {
    font-size: 13px;
    color: #555;
}

/* ===== 로딩 스피너 오버레이 ===== */
.login-loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.login-loading-spinner {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 4px solid #f0f0f0;
    border-top-color: #ff6a63;
    animation: login-spin 0.8s linear infinite;
    margin-bottom: 16px;
}

.login-loading-text {
    font-size: 14px;
    color: #111;
    font-weight: 400;
    text-align: center;
    line-height: 1.5;
    white-space: pre-line;
}

.login-loading-text::first-line {
    font-size: 16px;
    font-weight: 700;
}

@keyframes login-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* pass_img 클릭 시 사용하는 공통 스피너 */
.spinner {
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #2f86ff;
    border-radius: 50%;
    animation: login-spin 0.9s linear infinite;
}

/* ===== 에러 메시지 스타일 (첫 줄 크고 진하게, 둘째 줄 작고 얇게) ===== */
.login-error-message {
    color: #e53935;
    margin-top: 12px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 1.5;
    white-space: pre-line;
}

.login-error-message::first-line {
    font-size: 16px;
    font-weight: 700;
}

/* 회원가입 단계의 에러 메시지 (margin-bottom 추가) */
.login-error-message-signup {
    color: #e53935;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 1.5;
    white-space: pre-line;
}

.login-error-message-signup::first-line {
    font-size: 16px;
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/login.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gGAAgG;IAChG,WAAW;IACX,aAAa;IACb,iCAAiC;AACrC;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iCAAiC;AACjC;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,+BAA+B;IAC/B,aAAa;IACb,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,kDAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,sCAAsC;IACtC,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;;;;;;AAQA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,2DAA2D;AAC/D;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uGAAuG;IACvG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,yCAAyC;IACzC,4DAA4D;IAC5D,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,eAAe;AACf;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,UAAU;IACV,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR;;;kCAG8B;IAC9B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,oDAAoD;AACpD;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["/* 공통 래퍼 (그리드 2행: 위 1fr = 콘텐츠, 아래 auto = 키패드) */\r\n.login-wrap {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100dvh;\r\n    background: #fff;\r\n    overflow: hidden;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    color: #111;\r\n    display: grid;\r\n    grid-template-rows: 70px 1fr auto;\r\n}\r\n\r\n/* ===== 상태바(상단) — 필요 시 사용 ===== */\r\n.login-topbar {\r\n    position: absolute;\r\n    top: 8px;\r\n    left: 14px;\r\n    right: 14px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    pointer-events: none;\r\n    z-index: 2;\r\n}\r\n\r\n.login-time {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n}\r\n\r\n.login-status {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 600;\r\n}\r\n\r\n.login-signal {\r\n    width: 18px;\r\n    height: 10px;\r\n    position: relative;\r\n    display: inline-block;\r\n    border-right: 2px solid #000;\r\n}\r\n\r\n.login-signal::before,\r\n.login-signal::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 2px;\r\n    width: 3px;\r\n    background: #000;\r\n    border-radius: 1px;\r\n}\r\n\r\n.login-signal::before {\r\n    height: 6px;\r\n}\r\n\r\n.login-signal::after {\r\n    left: 8px;\r\n    height: 9px;\r\n}\r\n\r\n.login-5g {\r\n    font-size: 14px;\r\n}\r\n\r\n.login-battery {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    padding: 2px 8px;\r\n    border-radius: 999px;\r\n    background: #000;\r\n    color: #fff;\r\n    font-size: 12px;\r\n}\r\n\r\n.login-battery-level {\r\n    transform: translateY(0.5px);\r\n}\r\n\r\n/* ===== 헤더/카드 — 주석 상태 유지 ===== */\r\n.login-header {\r\n    padding: 20px 24px 0;\r\n}\r\n\r\n.login-back {\r\n    position: absolute;\r\n    top: 50px;\r\n    left: 0px;\r\n    border: none;\r\n    background: none;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    line-height: 1;\r\n    cursor: pointer;\r\n    color: #222;\r\n    padding: 20px;\r\n}\r\n\r\n.login-card {\r\n    margin-top: 25px;\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    gap: 12px 16px;\r\n    align-items: center;\r\n    padding: 14px 16px;\r\n    border-radius: 12px;\r\n    background: #f7f7f8;\r\n    border: 1px solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.login-card-left {\r\n    min-width: 0;\r\n}\r\n\r\n.login-name {\r\n    font-size: 18px;\r\n    font-weight: 800;\r\n}\r\n\r\n.login-card-right {\r\n    display: grid;\r\n    gap: 6px;\r\n    color: #6d6d6d;\r\n    font-size: 14px;\r\n}\r\n\r\n.login-meta span {\r\n    color: #9b9b9b;\r\n    margin-right: 8px;\r\n}\r\n\r\n/* ===== 상단 콘텐츠(중앙 정렬) ===== */\r\n.login-main {\r\n    min-height: calc(100dvh - 70px);\r\n    display: grid;\r\n    grid-template-rows: 50px 1fr auto;\r\n}\r\n\r\n/* ===== 타이틀 ===== */\r\n.login-title {\r\n    /* 기존: margin: 100px 24px 0;  → 중앙정렬 레이아웃에 맞게 수정 */\r\n    margin: 0 24px 14px;\r\n    text-align: center;\r\n    font-size: clamp(22px, 5.6vw, 30px);\r\n    font-weight: 900;\r\n}\r\n\r\n/* ===== PIN 점 표시 ===== */\r\n.login-pin-dots {\r\n    margin-top: 6px;\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 18px;\r\n}\r\n\r\n.login-dot {\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    background: #cfcfd3;\r\n}\r\n\r\n.login-dot.filled {\r\n    background: #4a4a4a;\r\n}\r\n\r\n/* ===== 본문 안내 ===== */\r\n.login-desc {\r\n    margin-top: 12px;\r\n    text-align: center;\r\n    color: #6c6c6c;\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.login-desc-sub {\r\n    margin: 28px 24px 0;\r\n    text-align: center;\r\n    color: #6c6c6c;\r\n    font-size: 15px;\r\n    line-height: 1.6;\r\n}\r\n\r\n/* ===== 섹션 타이틀(밑줄) — 필요시 사용 ===== */\r\n.login-section {\r\n    margin: 36px 24px 12px;\r\n    text-align: center;\r\n    font-weight: 800;\r\n    color: #4b4f58;\r\n    font-size: 20px;\r\n    position: relative;\r\n}\r\n\r\n.login-section span {\r\n    border-bottom: 3px solid #4b4f58;\r\n    display: inline-block;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n/* ===== 키패드 (그리드 2행에 배치) ===== */\r\n.login-keypad {\r\n    position: static;\r\n    left: auto;\r\n    right: auto;\r\n    bottom: auto;\r\n    background: #2f3a55;\r\n    color: #fff;\r\n    padding: 10px 24px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    grid-auto-rows: clamp(45px, 7vh, 60px);\r\n    gap: 10px 15px;\r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n\r\n.login-keypad button {\r\n    width: 100%;\r\n    max-width: 120px;\r\n    height: 64px;\r\n    border: none;\r\n    background: transparent;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #fff;\r\n    letter-spacing: 0.5px;\r\n    cursor: pointer;\r\n    pointer-events: auto;\r\n    touch-action: manipulation;\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.login-keypad button:active {\r\n    transform: scale(0.98);\r\n    background-color: #2a344d;\r\n}\r\n\r\n/* 특수키(좌/우 폭 넓게) */\r\n.key-wide {\r\n    max-width: none;\r\n    width: 100%;\r\n    font-size: 22px;\r\n    font-weight: 800;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.key-clear {\r\n    font-size: 20px !important;\r\n}\r\n\r\n.key-back {\r\n    font-size: 20px !important;\r\n}\r\n\r\n.login-top-logo {\r\n    padding-top: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.login-top-logo img {\r\n    height: 40px;\r\n    object-fit: contain;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Google 단계 전체 정렬 */\r\n\r\n.google-regist {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.google-main {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.google-circle-icon {\r\n    width: 100px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* 가운데 텍스트 */\r\n.google-center-text {\r\n    text-align: center;\r\n    font-size: 15px;\r\n    font-weight: 400;\r\n    line-height: 1.7;\r\n    white-space: pre-line;\r\n}\r\n\r\n.google-center-text::first-line {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n}\r\n\r\n.google-accent {\r\n    color: #e53935;\r\n    font-weight: 600;\r\n    display: inline-flex;\r\n    align-items: center;\r\n}\r\n\r\n.google-inline-icon {\r\n    margin-right: 4px;\r\n}\r\n\r\n.google-word {\r\n    margin-right: 2px;\r\n}\r\n\r\n/* 하단 버튼 영역 */\r\n.google-bottom-area {\r\n    width: 100%;\r\n    padding: 10px 24px 32px;\r\n}\r\n\r\n/* 회원가입 단계에서 하단 고정 */\r\n.google-regist .google-bottom-area {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background: #fff;\r\n    z-index: 100;\r\n    padding: 10px 24px calc(32px + env(safe-area-inset-bottom));\r\n}\r\n\r\n.google-bottom-btn {\r\n    width: 100%;\r\n    padding: 14px 0;\r\n    border-radius: 8px;\r\n    border: none;\r\n    background: #f0f0f0;\r\n    color: #111;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.google-bottom-btn:disabled {\r\n    opacity: 0.7;\r\n}\r\n\r\n/* 구글 공식 Sign-In 버튼 스타일 */\r\n.google-signin-btn {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    height: 50px;\r\n    padding: 0 24px;\r\n    border-radius: 4px;\r\n    border: 1px solid #dadce0;\r\n    background: #ffffff;\r\n    color: #3c4043;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 12px;\r\n    cursor: pointer;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\r\n    transition: box-shadow 0.2s ease, background-color 0.2s ease;\r\n    margin: 0 auto;\r\n}\r\n\r\n.google-signin-btn:hover {\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.google-signin-btn:active {\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n    background-color: #f1f3f4;\r\n}\r\n\r\n.google-signin-btn:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.2);\r\n}\r\n\r\n.google-signin-icon {\r\n    flex-shrink: 0;\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n.google-signin-text {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    color: #3c4043;\r\n    letter-spacing: 0.25px;\r\n}\r\n\r\n/* 닫기 텍스트 스타일 */\r\n.login-close-text {\r\n    display: block;\r\n    text-align: center;\r\n    color: #999;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding: 10px 0;\r\n}\r\n\r\n/* 구글 로그인 화면 전체를 더 크게 중앙에 */\r\n.google-main-large {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* justify-content: center; */\r\n    /* 세로 중앙 */\r\n    /* align-items: center; */\r\n    /* padding: 40px 24px 24px; */\r\n}\r\n\r\n/* 아이콘 크게 */\r\n.google-circle-icon-large {\r\n    width: 140px;\r\n    height: 140px;\r\n    object-fit: contain;\r\n}\r\n\r\n/* 텍스트도 조금 키움 */\r\n.google-center-text-large {\r\n    font-size: 20px;\r\n    line-height: 1.7;\r\n}\r\n\r\n/* 하단 영역 여유 */\r\n.google-bottom-area-large {\r\n    padding: 0 20px 40px;\r\n}\r\n\r\n/* 버튼 키우기 */\r\n.google-bottom-btn-large {\r\n    width: 100%;\r\n    height: 56px;\r\n    border-radius: 10px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.login-user-card {\r\n    width: 90%;\r\n    /* max-width: 360px; */\r\n    padding: 12px 16px;\r\n    border-radius: 12px;\r\n    background: #f7f7f7;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 4px;\r\n    /* position: absolute;\r\n    top: 100px;\r\n    left: 50%;\r\n    transform: translateX(-50%); */\r\n    border: 1px solid #e5e5e5;\r\n    margin: 0 auto;\r\n}\r\n\r\n.login-user-name {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.login-user-email {\r\n    font-size: 13px;\r\n    color: #555;\r\n}\r\n\r\n/* ===== 로딩 스피너 오버레이 ===== */\r\n.login-loading-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(255, 255, 255, 0.9);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 999;\r\n}\r\n\r\n.login-loading-spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    border: 4px solid #f0f0f0;\r\n    border-top-color: #ff6a63;\r\n    animation: login-spin 0.8s linear infinite;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.login-loading-text {\r\n    font-size: 14px;\r\n    color: #111;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    line-height: 1.5;\r\n    white-space: pre-line;\r\n}\r\n\r\n.login-loading-text::first-line {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n\r\n@keyframes login-spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n/* pass_img 클릭 시 사용하는 공통 스피너 */\r\n.spinner {\r\n    width: 48px;\r\n    height: 48px;\r\n    border: 4px solid #e5e7eb;\r\n    border-top-color: #2f86ff;\r\n    border-radius: 50%;\r\n    animation: login-spin 0.9s linear infinite;\r\n}\r\n\r\n/* ===== 에러 메시지 스타일 (첫 줄 크고 진하게, 둘째 줄 작고 얇게) ===== */\r\n.login-error-message {\r\n    color: #e53935;\r\n    margin-top: 12px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    line-height: 1.5;\r\n    white-space: pre-line;\r\n}\r\n\r\n.login-error-message::first-line {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n\r\n/* 회원가입 단계의 에러 메시지 (margin-bottom 추가) */\r\n.login-error-message-signup {\r\n    color: #e53935;\r\n    margin-bottom: 16px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    line-height: 1.5;\r\n    white-space: pre-line;\r\n}\r\n\r\n.login-error-message-signup::first-line {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
